<template>
  <div class="app_container">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :name="item.name"
        :label="item.label"
      />
    </el-tabs>
    <keep-alive>
      <component :is="activeName" ref="childComp" />
    </keep-alive>
  </div>
</template>

<script>
import sureMember from "./sureMember/index.vue";
import protocolMember from "./protocolMember/index.vue";
import { tamePage } from "@/api/enrollOffline";

export default {
  name: "offlineClassTransferStudents",
  components: {
    sureMember,
    protocolMember,
  },
  data() {
    return {
      tabList: [
        { label: "确定名单", name: "sureMember" },
        { label: "拟定名单", name: "protocolMember" },
      ],
      activeName: "sureMember",
    };
  },
  created() {
    // tamePage({ classId: this.$route.query.id, isSure: 1 }).then(
    //   ({ code, data }) => {
    //     if (code !== 0) return;
    //     const { total = 0 } = data;
    //     if (total === 0) {
    //       this.activeName = "protocolMember";
    //     }
    //   }
    // );
  },
  methods: {
    handleClick(tab, event) {
      this.$nextTick(() => {
        this.$refs.childComp.childSearch();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>